import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import NailShop from "./pages/NailShop";
import NavBar from './components/NavBar';
import Styling from "./pages/Styling";
import Cart from "./pages/Cart";
import TechRedirect from "./pages/TechRedirect";
import ThankYou from './pages/ThankYou';
import { initGA } from './utils/analytics';
import Experience from "./components/Experience";
import OnHand from './components/OnHand';          
import OnHandDetail from './components/OnHandDetail';
import Signature from './components/Signature';
import SignatureDetail from './components/SignatureDetail';
import RouteTracker from './components/RouteTracker';
import FloatingCartButton from "./components/FloatingCartButton";
import FAQ from "./pages/Faq";
import ProductDetail from "./pages/ProductDetail";
import Featured from './components/Featured';

function App() {
  useEffect(() => { initGA(); }, []);
  const location = useLocation();
  const showCart = location.pathname.startsWith('/nails') && !location.pathname.includes('/cart');
  const showNailsNav = location.pathname.startsWith('/nails');

  return (
    <div>
      {showNailsNav && <NavBar />}
      <RouteTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nails" element={<NailShop />} />
        <Route path="/nails/:slug" element={<ProductDetail />} />
        <Route path="/nails/featured" element={<Featured />} />
        <Route path="/nails/experience" element={<Experience />} />           
        <Route path="/nails/onhand" element={<OnHand />} />             
        <Route path="/nails/onhand/:slug" element={<OnHandDetail />} />
        <Route path="/nails/signature" element={<Signature />} />
        <Route path="/nails/signature/:slug" element={<SignatureDetail />} />
        <Route path="/nails/faq" element={<FAQ />} />
        <Route path="/nails/cart" element={<Cart />} />
        <Route path="/nails/thank-you" element={<ThankYou />} />
        <Route path="/styling" element={<Styling />} />
        <Route path="/tech" element={<TechRedirect />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {showCart && <FloatingCartButton />}
    </div>
  );
}

export default App;
